import { getGAClientId } from "@gigpro/utils";
import { setConfig } from "@sidegigllc/api/client";
import { env } from "config/env";
import { getActiveLocationId } from "services/atoms";
import { AUTHENTICATION_HEADER, GA4_CLIENT_ID_HEADER, GIGPRO_LOCATION_HEADER } from "./constants";
import { getTokenSilently } from "./helpers";

function getRequestHeaders(): Record<string, string> {
  const headers: Record<string, string> = {};
  if (env.IS_AUTOMATION) {
    const token = getTokenSilently();
    if (token) headers[AUTHENTICATION_HEADER] = `Bearer ${token}`;
  }
  const locationId = getActiveLocationId();
  if (locationId) headers[GIGPRO_LOCATION_HEADER] = String(locationId);
  const gaClientId = getGAClientId();
  if (gaClientId) headers[GA4_CLIENT_ID_HEADER] = gaClientId;
  return headers;
}

setConfig({
  baseUrl: env.REACT_APP_SG_API_URL,
  defaultHeaders: getRequestHeaders,
});
